/* Splash screen — plays on every page load, ~1s show + fade.
 * No localStorage flag any more; the mark assembly animation is the brand
 * touch we want to surface every time the app boots. */

import { useEffect, useState } from 'react';
import { VilkaMark } from './mark.jsx';

export function Splash({ onDone }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const showFor = reduce ? 200 : 1000;
    const fadeFor = 280;
    const t1 = setTimeout(() => setExiting(true), showFor);
    const t2 = setTimeout(() => onDone(), showFor + fadeFor);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div className={'splash ' + (exiting ? 'is-exiting' : '')}>
      <VilkaMark variant="yellow-square" size={160} anim="assemble" />
    </div>
  );
}
